// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome__container___1RlvM","banner":"Welcome__banner___2-rUf","subtitle":"Welcome__subtitle___3qDd4"};